import * as React from 'react';
import {view, deprecatedCss} from '@sail/engine';
import {Checkbox} from '@sail/ui';

export const Indeterminate = () => {
  const [checked1, setChecked1] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  return (
    <view.div
      uses={[
        deprecatedCss`
          layout: column;
        `,
      ]}
    >
      <Checkbox
        label="This Checkbox is aggregating the state of the Checkboxes below it."
        checked={checked1 && checked2}
        readOnly
        indeterminate={checked1 !== checked2}
      />
      <ul>
        <li>
          <Checkbox
            label="Checkbox 1"
            checked={checked1}
            onChange={() => {
              setChecked1(!checked1);
            }}
          />
        </li>
        <li>
          <Checkbox
            label="Checkbox 2"
            checked={checked2}
            onChange={() => {
              setChecked2(!checked2);
            }}
          />
        </li>
      </ul>
    </view.div>
  );
};
